export { InviteProjectModalBody, InviteTeamModalBody } from "./InviteModalBodies"
export { JoinTeamModalBody } from "./JoinTeamModalBody"
export { JoinProjectModalBody } from "./JoinProjectModalBody"
export { LeaveProjectModalBody, openLeaveProjectModal } from "./LeaveProjectModalBody"
export { LeaveTeamModalBody, openLeaveTeamModal } from "./LeaveTeamModalBody"
export { ShortDescriptionModalBody, FullDescriptionModalBody } from "./ShortDescriptionModalBody"
export { ProjectLikesModalBody } from "./ProjectLikesModalBody"
export { ProjectExternalLinksModalBody } from "./ProjectExternalLinksModalBody"
export { ProjectMembersModalBody } from "./ProjectMembersModalBody"
export { TeamMembersModalBody } from "./TeamMembersModalBody"
export { TeamProjectsModalBody } from "./TeamProjectsModalBody"
export { UserFollowersModalBody } from "./UserFollowersModalBody"
export { CommentThreadModalBody } from "./CommentThreadModalBody"
export { ReportModalBody, openPlatformReportModal } from "./ReportModalBody"

export const mockTeams = [
  { label: "Команда 1", value: 1 },
  { label: "Команда 2", value: 2 },
]
